<template>
  <div class="foot">大儒心理咨询中心备案号：京ICP备20031619号-1</div>
</template>

<script>
export default {};
</script>

<style  scoped>
.foot {
  line-height: 50px;
  background-color: #898989;
  text-align: center;
  color: #fff;
  border-top: 1px solid #fff;
}
</style>